import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import About from "./Pages/About";
import Dashboard from "./Admin/Dashboard";
import Login from "./Admin/Login";
import PrivateRoute from "./Admin/PrivateRoute";
import Shop from "./Pages/Shop";
import ProductDetail from "./Pages/ProductDetail";
import Cart from "./Pages/Cart";
import Checkout from "./Pages/Checkout";
import Faq from "./Pages/Faq";
import BulkOrderPopup from "./Components/BulkOrderPopup";
import OrderSuccess from "./Pages/OrderSuccess";

function App() {

  const location = useLocation();

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
     <BulkOrderPopup />

      {!isAdmin && <Navbar />}

      <Routes>

        <Route path="/" element={<Home />} />
         <Route 
 path="/product/:id" 
 element={<ProductDetail />} 
/>
        <Route path="/about" element={<About />} />

        <Route path="/admin/login" element={<Login />} />
        <Route path="/shop" element={<Shop />} />
        <Route
  path="/order-success"
  element={<OrderSuccess />}
/>
        <Route path="/cart" element={<Cart/>}/>
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/faq" element={<Faq />} />
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

      </Routes>

      {!isAdmin && <Footer />}
    </>
  );
}

export default App;